import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { OtherCodeResponse } from "@/Patient/Api/MedfarBilling/Dto/Responses/OtherCodeResponse";
import { MedfarBillingAutoCompleteOtherCode } from "@/Patient/Components/MedfarBilling/MedfarBillingAutoCompleteOtherCode";

interface IMedfarBillingFavoriteCodePopupProps {
    onCloseCallback: () => void;
    IsSpecialist: boolean;
}

class MedfarBillingFavoriteCodePopupState {
    public FavoriteCode: string;
    public FavoriteDescription: string;
}

class MedfarBillingFavoriteCodePopup extends React.Component<IMedfarBillingFavoriteCodePopupProps, MedfarBillingFavoriteCodePopupState> {
    constructor(props: IMedfarBillingFavoriteCodePopupProps) {
        super(props);

        const initialState = new MedfarBillingFavoriteCodePopupState();
        initialState.FavoriteCode = "";
        initialState.FavoriteDescription = "";
        this.state = initialState;
    }

    public render(): JSX.Element {
        return (
            <div className="fmp-favotite-popup">
                <div className="fmpf-header">
                    <h2>Ajout d'un favori</h2>
                </div>
                <div className="fmpf-main">
                    <div className="flex-container flex-start" style={{ marginBottom: "5px" }}>
                        <div className="row">
                            <div className="col-sm-3 col-md-3 col-lg-3 text-right">
                                <label style={{ marginTop: "5px" }}>
                                    Code:
                                </label>
                            </div>
                            <div className="col-sm-9 col-md-9 col-lg-9">
                                <MedfarBillingAutoCompleteOtherCode
                                    serverOperation={ServerOperations.Server.MedfarBilling_SearchOtherCode}
                                    onItemSelectCallBack={item => this.onOtherCodeItemSelect(item)}
                                    IsSpecialist={this.props.IsSpecialist}
                                    ClearCodeOnSelect={false}
                                    onCodeChange={code => this.onCodeChange(code)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="flex-container flex-start" style={{ marginBottom: "10px" }}>
                        <div className="row">
                            <div className="col-sm-3 col-md-3 col-lg-3 text-right">
                                <label style={{ marginTop: "5px" }}>
                                    Description:
                                </label>
                            </div>
                            <div className="col-sm-9 col-md-9 col-lg-9">
                                <input className="form-control" type="text" value={this.state.FavoriteDescription} onChange={e => this.onDescriptionChange(e)} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="fmpf-footer">
                    <div className="text-right">
                        <button className="btn btn-default" onClick={() => this.props.onCloseCallback()} style={{ marginRight: "5px" }}><span>{cacheStore.GetString("CancelLabel")}</span></button>
                        <button className="btn btn-primary" onClick={this.onAddNewFavoriteClick.bind(this)} disabled={this.state.FavoriteCode === ""}><span>{cacheStore.GetString("AddLabel")}</span></button>
                    </div>
                </div>
            </div>
        );
    }

    private onDescriptionChange(e: React.ChangeEvent<HTMLInputElement>): void {
        var s = new MedfarBillingFavoriteCodePopupState();
        s.FavoriteDescription = e.target.value;
        this.setState(s);
    }

    private onAddNewFavoriteClick(): void {
        var op = new LocalEvent(LocalPatientOperations.MedfarBilling.OnAddNewFavoriteClick);
        op.AddItem("code", this.state.FavoriteCode);
        op.AddItem("description", this.state.FavoriteDescription);
        LocalEventDispatcher.dispatch(op);
    }

    private onOtherCodeItemSelect(item: OtherCodeResponse): void {
        var s = new MedfarBillingFavoriteCodePopupState();
        s.FavoriteCode = item.Code;
        s.FavoriteDescription = item.Description;
        this.setState(s);
    }

    private onCodeChange(val: string): void {
        var s = new MedfarBillingFavoriteCodePopupState();
        s.FavoriteCode = val;
        this.setState(s);
    }
}

export { MedfarBillingFavoriteCodePopup };
